var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoyntDevice = function SvgPoyntDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.03 20H3.132a1 1 0 0 1-.992-1.122l1.723-14A1 1 0 0 1 4.854 4H16m-1.97 16h2.095a1 1 0 0 0 .991-.868L18 12.5M14.03 20 16 4m0 0 3 1m0 0 2.317.772a.99.99 0 0 1 .68.948c-.03 2.537-.359 6.144-3.997 5.78M19 5l-1 7.5m-11.53-6h6.5l-1.5 11h-6.5l1.5-11Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgPoyntDevice;